import { render, staticRenderFns } from "./FacultyElement.vue?vue&type=template&id=882b1b3e&scoped=true&"
import script from "./FacultyElement.vue?vue&type=script&lang=js&"
export * from "./FacultyElement.vue?vue&type=script&lang=js&"
import style0 from "./FacultyElement.vue?vue&type=style&index=0&id=882b1b3e&scoped=true&lang=scss&"
import style1 from "./FacultyElement.vue?vue&type=style&index=1&id=882b1b3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882b1b3e",
  null
  
)

export default component.exports